declare let mxGeometryChange: any; // available globally
declare let mxStyleChange: any; // available globally
declare let mxTerminalChange: any; // available globally
import {xmlToObj} from '../../diagram-render/helpers/xml-to-obj.util';
import * as _ from 'lodash';

export function activityGraphChange(graph, cell, change) {
  const geometry = cell.geometry;
  const action: any = {};

  action.mxKey = cell.id;
  action.position = {
    x: geometry.x,
    y: geometry.y,
    w: geometry.width,
    h: geometry.height
  };
  action.text = graph.getEditingValue(cell);

  // if not mxGeometryChange than update number and text
  if (!(change instanceof mxGeometryChange)) {
    action.number = cell.comp.instance.source.number;
  }

  if (change instanceof mxStyleChange) {
    const prev = xmlToObj(change.previous);
    const curr = xmlToObj(change.style);

    if (+prev.locked !== +curr.locked) {
      action.locked = Boolean(+curr.locked);
    }
  }

  return {
    data: _.cloneDeep(action),
    action: 'changeActivity',
    type: 'activity',
    mxKey: Number(cell.id)
  };
}
